import React, { forwardRef } from "react";

import { format } from "date-fns";

import { Box, Flex, Spacer, Text, HStack, Stack, Icon } from "@chakra-ui/react";
import { IoIosArrowDown } from "react-icons/io";

import logoMCA from "../../../img-docs/logomca.png";
import TableSA from "../TableSA";
import { useAuthProvider } from "../../../Context/AuthProvider";
import SemRegistros from "../SemRegistros";

export const ComponentToPrintCriancaAvisos = forwardRef((props, ref) => {
  const { roleKeycloack } = useAuthProvider();

  const destaquesPorAviso = {
    1: ["últimos 7 dias"],
    2: ["mais de 15 dias"],
    3: ["mais de 2 meses"],
    4: ["mais de 18 meses"],
    5: ["mais de 2 meses"],
    6: ["requisitos para adoção"],
    7: ["fora da sua área de atuação"],
  };

  function destacarTexto(texto, destaques = []) {
    if (!destaques.length) return texto;

    const regex = new RegExp(
      `(${destaques.map(escapeRegExp).join("|")})`,
      "gi"
    );

    function escapeRegExp(string) {
      return string.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
    }

    const partes = texto.split(regex);

    return partes.map((parte, i) =>
      destaques.some((d) => d.toLowerCase() === parte.toLowerCase()) ? (
        <Text as="strong" key={i}>
          {parte}
        </Text>
      ) : (
        parte
      )
    );
  }
  return (
    <Box display="block" ref={ref}>
      <table width={props.previewLayout ? "100%" : ""}>
        <thead>
          <tr>
            <td>
              {/* Header Spacer */}
              <Box height="50px" />
            </td>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>
              <Box display="break-page">
                <Flex
                  bgColor={"#16949933"}
                  px="20px"
                  py="16px"
                  border={"solid 1px #DEE2E6"}
                  borderTop={"solid 3px #169499"}
                  alignItems="center"
                  justifyContent={"space-between"}
                  cursor={"pointer"}
                  mt={10}
                >
                  <Text
                    color={"#1A203D"}
                    fontWeight="500"
                    fontSize="14px"
                    lineHeight="21.6px"
                    ml={3}
                  >
                    {destacarTexto(
                      props?.descricaoTipoAviso?.descricaoTipoAviso ?? "",
                      destaquesPorAviso[
                        props?.descricaoTipoAviso?.idTipoAviso
                      ] || []
                    )}
                  </Text>
                  <Icon
                    aria-label="Files"
                    color="#169499"
                    as={IoIosArrowDown}
                    boxSize="20px"
                  />
                </Flex>

                <Stack alignItems="center" px={4}>
                  <Box display={"block"}>
                    {props.dataPendencias && props.dataPendencias.length > 0 ? (
                      <TableSA
                        data={props.dataPendencias}
                        columns={props.columnsAvisos}
                        entidade="crianca-dashboard-avisos"
                        roleKeycloack={roleKeycloack}
                        isPrint={true}
                        disableHeaderOptions
                        disableHeaderOptionsOpcoes
                        disableHeaderOptionsPagination
                      />
                    ) : (
                      <Box mt={4}>
                        <SemRegistros buttonVisible={true} half />
                      </Box>
                    )}
                  </Box>
                </Stack>
              </Box>
            </td>
          </tr>
        </tbody>
        <tfoot>
          <tr>
            <td>
              {/* Footer Spacer */}
              <Box height="40px" />
            </td>
          </tr>
        </tfoot>
      </table>

      {/* Header */}
      <HStack
        position="fixed"
        top={0}
        pt="17.5px"
        pb="10px"
        alignItems="end"
        justifyContent="space-between"
        backgroundColor="#FFF"
        zIndex={100}
        width="100%"
      >
        <img
          src={logoMCA}
          alt="LogoMCA"
          style={{ width: "200px", height: "60px" }}
        />

        <Text
          fontWeight={700}
          fontSize="20px"
          lineHeight="21.6px"
          color="#464648"
          textAlign="center"
          flex={1}
        >
          {"Aviso".toUpperCase()}
        </Text>

        <Box width="200px" />
      </HStack>

      {/* Footer */}

      <Flex
        position="fixed"
        bottom={0}
        pt="10px"
        w="100%"
        px="15px"
        backgroundColor="#FFF"
        zIndex={100}
      >
        <HStack spacing="35px">
          <Text>{format(new Date(), "dd/MM/yyyy")}</Text>
          <Text>{format(new Date(), "HH:mm:ss")}</Text>
        </HStack>

        <Spacer />

        <Text id="pageForPrint">Página</Text>
      </Flex>
    </Box>
  );
});
